import {doc, getDoc} from 'firebase/firestore';
import {FunctionsPersistStore, FirestoreCollection, Keys} from 'hubbl-shared';
import {firestore} from './firebase';

const getDefaultConfig = async (): Promise<
  FunctionsPersistStore | undefined
> => {
  try {
    const generalSettingsRef = doc(
      firestore,
      FirestoreCollection.FunctionsPersistStore,
      Keys.defaultFunctionsPersistStoreId,
    );

    const snapshot = await getDoc(generalSettingsRef);

    if (snapshot.exists()) {
      return snapshot.data() as FunctionsPersistStore;
    }

    return undefined;
  } catch (error) {
    console.error('Error fetching general settings:', error);
    return undefined;
  }
};

export const generalSettings = {
  getDefaultConfig,
};
